import { AddOnWithOrganizationStatusDto } from './AddOnDto';
import { PackageDto } from './PackageDto';
import moment from 'moment-timezone';
import { UserDto } from './UserDto';

export interface PlanTransactionDto {
  id: string;
  total: number;
  date: string;
}

export interface PlanDto {
  id: string;
  package: PackageDto;
  addOns: AddOnWithOrganizationStatusDto[];
  termLengthInYears: number;
  maxActiveEvents: number;
  startDate: string;
  endDate: string;
  nextInvoiceDate: string | null;
  createdByUser: UserDto | null;
}

export function getPlanEndCountdown(plan: PlanDto | null): number {
  if (!plan) return 0;
  const userTimezone = moment.tz.guess(true);
  const endMoment = moment(plan.endDate).tz(userTimezone);
  if (endMoment.isBefore(moment())) return 0;
  return Math.ceil(endMoment.diff(moment(), 'days', true));
}
